var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorkshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon workshop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.447 24a2.418 2.418 0 0 1-1.581-.706l-7.548-7.55.741-.744 7.549 7.55a1.372 1.372 0 0 0 1.94-1.94L15 13.062l.742-.742 7.549 7.549A2.421 2.421 0 0 1 21.71 24zm-20.87-.576a1.894 1.894 0 0 1 .03-2.676l14.24-14.24a4.826 4.826 0 0 1 6.2-6.2L19.3 2.056A1.871 1.871 0 1 0 21.945 4.7l1.747-1.747a4.668 4.668 0 0 1 .257.978v1.388a4.849 4.849 0 0 1-1.372 2.719 4.788 4.788 0 0 1-5.083 1.116L3.253 23.395a1.93 1.93 0 0 1-1.365.568 1.845 1.845 0 0 1-1.311-.539zm.737-1.968a.893.893 0 0 0-.031 1.261.894.894 0 0 0 1.262-.03l14.7-14.7.606.232a3.788 3.788 0 0 0 4.018-.888 3.848 3.848 0 0 0 1.1-2.24l-.318.318a2.9 2.9 0 0 1-4.09.03 2.9 2.9 0 0 1 .03-4.09l.319-.318a3.85 3.85 0 0 0-2.241 1.1 3.788 3.788 0 0 0-.888 4.018l.232.606zM4.757 5.874 3.6 7.029a.6.6 0 0 1-.856 0l-2.6-4.3A.639.639 0 0 1 0 2.353V2.3a.608.608 0 0 1 .177-.4L1.89.181a.6.6 0 0 1 .843-.012L7.026 2.75a.606.606 0 0 1 0 .856L5.74 4.893l4.655 4.655-.982.981zM1.166 2.389l2.107 3.485 2.6-2.6-3.494-2.1z",
    transform: "translate(.001)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkshop);
export default __webpack_public_path__ + "static/media/iconWorkshop.1770030c3005264d94a430053510f10b.svg";
export { ForwardRef as ReactComponent };